import { useRef } from 'react';
import { useSteppedAnimation } from './useSteppedAnimation';
import { useTransform } from 'framer-motion';

/**
 * Splits a word into its letters and gets all variants
 * of arranging those letters
 */
const getVariantsForWord = (word) => {
  const len = word.length;

  const words = word.split('').map((_, letterIdx) => {
    return Array.from({ length: len })
      .map((_, idx) => {
        const offset = letterIdx + idx;
        return word[offset % len];
      })
      .join('');
  });

  return words;
};

/**
 * Checks if a text contains a space.
 */
export const hasSpace = (text) => {
  return text.split('').some((c) => c === ' ');
};

/**
 * Set up a stepped letter animation.
 */
export const useSteppedLetterAnimation = ({
  text,
  duration = 1,
  maxVelocity
}) => {
  /**
   * The ref is a workaround for now, because the version of Framer
   * used hasn't support for using MotionValues as children directly.
   *
   * To update to the latest Frame we need to update to the latest
   * Gatsby (5) and React (18) tho.
   *
   * TODO
   */
  const ref = useRef(null);

  /**
   * If the input text contains a space we add a space to the
   * end of the animated text, so we get a space when the text
   * wraps around.
   *
   * Turns "GET IN TOUCHGET IN TOUCH" into "GET IN TOUCH GET IN TOUCH"
   */
  const cleanedText = hasSpace(text) ? `${text} ` : text;
  const variants = getVariantsForWord(cleanedText);

  const [progress, actions] = useSteppedAnimation({
    steps: text.length,
    duration,
    maxVelocity,
    speedUp: 1,
    slowDown: 8
  });

  const displayText = useTransform(progress, (latest) => {
    return variants[latest % variants.length];
  });

  useTransform(displayText, (latest) => {
    if (!ref.current) return;
    ref.current.innerText = latest;
  });

  return [ref, actions];
};
